import { Card, CardBody } from "@heroui/react";
import { LuPlus } from "react-icons/lu";
import { ThemedText } from "@/components/ui";

const TambahBarakCard = ({ onClick }) => {
    return (
        <Card
            isPressable
            onPress={onClick}
            shadow="none"
            className="h-full min-h-[200px] border border-dashed border-zinc-300 bg-transparent transition-colors hover:bg-zinc-50 dark:border-zinc-700 dark:hover:bg-zinc-800/50"
        >
            <CardBody className="flex flex-col items-center justify-center gap-2 p-4">
                <div className="rounded-full bg-zinc-100 p-2 text-zinc-400 dark:bg-zinc-800">
                    <LuPlus size={24} />
                </div>
                <ThemedText size="sm" variant="secondary">
                    Tambah Barak
                </ThemedText>
            </CardBody>
        </Card>
    );
};

export default TambahBarakCard;
